import shiColors from "../../theme/shiColors";
import { LIFECYCLE_BILLING, LIFECYCLE_REFRESH, LIFECYCLE_RENEWAL } from "./constants";

export function getLifecycleManagementEventTypeColor(eventType: string): string {
    switch (eventType) {
        case LIFECYCLE_RENEWAL:
            return shiColors.blue.DEFAULT;
        case LIFECYCLE_REFRESH:
            return shiColors.pink.DEFAULT;
        case LIFECYCLE_BILLING:
            return shiColors.green.DEFAULT;
        default:
            return shiColors.black;
    }
}